import { SystemStyleObject } from '@chakra-ui/react';

interface AudioPlayerDetailsSx {
  details: SystemStyleObject;
  songTitle: SystemStyleObject;
}

export const audioPlayerDetailsSx: () => AudioPlayerDetailsSx = () => ({
  details: {
    display: { base: 'none', md: 'flex' },
    flex: '1 1 50%',
    minWidth: { base: 150, xl: 250 },
    maxWidth: { base: 200, xl: 'initial' },
    alignItems: 'center',
    fontSize: 14,
    whiteSpace: 'nowrap',
    paddingRight: 4,
  },
  songTitle: {
    color: 'textSubdued',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textDecoration: 'none',
    fontSize: 'xs',
    ':hover': {
      color: 'textBase',
      textDecoration: 'none',
    },
  },
});
